(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-is"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-is", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["Recharts"] = factory(require("react"), require("react-is"), require("react-dom"));
	else
		root["Recharts"] = factory(root["React"], root["ReactIs"], root["ReactDOM"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__442__, __WEBPACK_EXTERNAL_MODULE__751__, __WEBPACK_EXTERNAL_MODULE__3__) => {
return 